export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallView.vue?vue&type=template&id=4d6d26ca&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/userVideo/SmallView.vue?vue&type=template&id=4d6d26ca&
// module id = null
// module chunks = 